export default __webpack_public_path__ + "static/char-s-62-zh-Hant-fb443b1cbeb002e4a4da8ab84afedbac.webp";